// Provider options for emergency alerts
export const PROVIDERS = [
    { name: 'InformaCast', code: 'informaCast' },
    { name: 'Raptor', code: 'raptor' },
];

export const PROVIDERS_MAP = {
    informaCast: 'InformaCast',
    raptor: 'Raptor',
};

// Alert type options
export const ALERT_TYPES = [
    { name: 'Fire', code: 'Fire' },
    { name: 'Weather', code: 'Weather' },
    { name: 'Safety', code: 'Safety' },
    { name: 'Security', code: 'Security' },
    { name: 'Environment', code: 'Environment' },
    { name: 'Geography', code: 'Geography' },
    { name: 'Rescue', code: 'Rescue' },
    { name: 'Health', code: 'Health' },
    { name: 'Transport', code: 'Transport' },
    { name: 'Infrastructure', code: 'Infrastructure' },
    { name: 'CBRNE', code: 'CBRNE' },
    { name: 'Other', code: 'Other' },
];

// Color options for template customization
export const COLOR_OPTIONS = [
    { name: 'Red', code: '#FF0000' },
    { name: 'Blue', code: '#0000FF' },
    { name: 'Green', code: '#00FF00' },
    { name: 'Yellow', code: '#FFFF00' },
    { name: 'Orange', code: '#FFA500' },
    { name: 'Purple', code: '#800080' },
    { name: 'Pink', code: '#FFC0CB' },
    { name: 'Black', code: '#000000' },
    { name: 'White', code: '#FFFFFF' },
    { name: 'Gray', code: '#808080' },
    { name: 'Brown', code: '#A52A2A' },
    { name: 'Cyan', code: '#00FFFF' },
];

// Table column configuration
export const TABLE_COLUMNS = [
    {
        field: 'title',
        header: 'Alert',
        width: '30%',
        minWidth: '20rem',
        sortable: true,
    },
    {
        field: 'alertType',
        header: 'Alert Type',
        width: '20%',
        minWidth: '10rem',
        sortable: true,
    },
    {
        field: 'alertProvider',
        header: 'Alert Provider',
        width: '20%',
        minWidth: '10rem',
        sortable: true,
    },
    {
        header: 'Updated Date',
        field: 'updatedAt',
        width: '20%',
        minWidth: '10rem',
        sortable: true,
    },
    {
        header: 'Action',
        minWidth: '5rem',
    },
];
